<template>
  <div id="content">
    <sweet-modal ref="modal" title="Nouvel utilisateur">
      <form>
        <label for="fullname">Nom Complet</label>
        <input
          type="text"
          id="fullname"
          name="fullname"
          v-model="form.fullname"
          placeholder="Nom complet"
        />
        <div class="error">{{ errors.first("fullname") }}</div>
        <br />
        <label for="role">Rôles</label>
        <multiselect
          v-model="form.role"
          :options="typeList"
          name="role"
          id="role"
          :searchable="false"
          :show-labels="false"
          v-validate="'required'"
          placeholder="Sélectionnez un rôle"
        >
        </multiselect>
        <div class="error">{{ errors.first("role") }}</div>
        <br />
        <label for="email">Identifiant Client</label>
        <input
          type="email"
          v-model="form.identifiant"
          name="identifiant"
          id="identifiant"
          placeholder="Ex : Gardena "
        />
        <div class="error">{{ errors.first("identifiant") }}</div>
        <br />
        <label for="email">Adresse email <span>*</span></label>
        <input
          type="email"
          v-model="form.email"
          name="email"
          id="email"
          v-validate="'required|email'"
          placeholder="Adresse email"
        />
        <div class="error">{{ errors.first("email") }}</div>
        <br />
        <label for="password">Mot de passe <span>*</span></label>
        <input
          type="password"
          v-model="form.password"
          name="password"
          id="password"
          ref="password"
          data-vv-as="mot de passe"
          v-validate="'required|min:6|max:35'"
          placeholder="Mot de passe"
        />
        <div class="error">{{ errors.first("password") }}</div>
        <br />
        <label for="confirm">Confirmer le mot de passe <span>*</span></label>
        <input
          type="password"
          v-model="form.confirm"
          name="confirm"
          id="confirm"
          data-vv-as="confirmer"
          v-validate="'required|confirmed:password'"
          placeholder="Confirmez le mot de passe"
        />
        <div class="error">{{ errors.first("confirm") }}</div>
        <br />
        <span class="obl">*Champs obligatoires</span>
        <br />
        <div class="form-end">
          <button class="btn-red" v-on:click="closeModal()">Annuler</button
          >&nbsp;
          <button class="btn-blue" v-on:click="submited()">
            <i class="fa fa-save"></i> Créer
          </button>
        </div>
      </form>
    </sweet-modal>
    <div class="contenair homeop">
      <h1>
        <i class="fa fa-address-book-o" aria-hidden="true"></i> Utilisateurs
      </h1>
      <div class="add-op">
        <button class="btn-blue" v-on:click="openModal()">
          <i class="fa fa-plus"></i> Nouvel utilisateur
        </button>
      </div>
      <br />
      <br />
      <h3>{{ totalUsers }} utilisateurs</h3>

      <br />
      <div>
        <div class="bloc-user" v-for="(item, index) in users" :key="index">
          <div class="userlist">
            <div>
              <router-link :to="'/user/' + item._id">{{
                item.email
              }}</router-link>
            </div>
            <div>
              <i class="fa fa-trash-o" v-on:click="deleteUser(item._id)"></i>
              &nbsp;|&nbsp;
              <router-link :to="'/user/' + item._id"
                ><i class="fa fa-pencil-square-o" aria-hidden="true"></i
              ></router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { SweetModal, SweetModalTab } from "sweet-modal-vue";
import Multiselect from "vue-multiselect";

export default {
  name: "users",
  components: {
    SweetModal,
    SweetModalTab,
    Multiselect,
  },
  data: function() {
    return {
      users: [],
      totalUsers: 0,
      typeList: ["ADMIN", "CLIENT"],
      form: {
        identifiant: undefined,
        fullname: undefined,
        email: undefined,
        password: undefined,
        confirm: undefined,
      },
    };
  },
  mounted() {
    this.load();
  },
  methods: {
    async submited() {
      event.preventDefault();

      this.$validator.validateAll().then(async (valid) => {
        if (valid) {
          try {
            let result = await this.$axios.post("/api/users/save",
              {
                ...this.form,
              }
            );

            if (result.data) {
              this.$router.push("/user/" + result.data);
            }
          } catch (error) {
            console.log(error);
          }
        }
      });
    },
    load() {
      this.$axios
        .get("/api/users/list")
        .then((response) => {
          this.users = response.data;
        })
        .catch((error) => {
          console.log(error);
        });

      this.$axios
        .get( "/api/users/count")
        .then((response) => {
          this.totalUsers = response.data.status;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    closeModal() {
      event.preventDefault();
      this.$refs.modal.close();
      return;
    },
    openModal() {
      this.$refs.modal.open();
      return;
    },
    deleteUser(id) {
      this.$swal({
        title: "&Ecirc;tes vous sur ?",
        text: "Supprimer cet utilisateur ?",
        type: "warning",
        showCancelButton: true,
        cancelButtonText: "Annuler",
        confirmButtonText: "Oui, je le supprime !",
      }).then((result) => {
        if (result.value) {
          this.$axios
            .get("/api/users/delete/" + id)
            .then((response) => {
              this.$swal(
                "Supprimée !",
                "L'utilisateur à bien été supprimée.",
                "success"
              );
              this.load();
            })
            .catch((error) => {
              console.log(error);
            });
        }
      });
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
